module.exports = __webpack_public_path__ + "static/media/boilerplate.2cf13c2c.png";